
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import './ExpansionPanel.scss'

const MyExpansionPanel = ({ title, children, expanded, changeId, onChange }) => {
  const ref = useRef(null);

  function handleChange(event, isOpen) {
    onChange(isOpen, changeId);
    if (!isOpen) return;

    onExpand();
    function onExpand(lastHeight, numberIterationsHeightDoesNotChange) {
      const { clientHeight, offsetTop, parentElement } = ref.current;

      /* scroll the parent block so that this one doesn't hide */
      const parentWithScroll = document.body.clientWidth < 960 ? document.documentElement : parentElement;
      const newParentScrollTop =
        (clientHeight + offsetTop) - (parentWithScroll.offsetTop + parentWithScroll.clientHeight);
      if (parentWithScroll.scrollTop < newParentScrollTop) {
        parentWithScroll.scrollTop = newParentScrollTop;
      }

      numberIterationsHeightDoesNotChange = lastHeight === clientHeight ? numberIterationsHeightDoesNotChange + 1 : 0;
      if (numberIterationsHeightDoesNotChange < 10) {
        setTimeout(onExpand, 10, clientHeight, numberIterationsHeightDoesNotChange);
      }
    }
  }

  return (
    <Accordion ref={ref} defaultExpanded expanded={expanded} onChange={handleChange}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>{title}</AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  )
}

MyExpansionPanel.propTypes = {
  title: PropTypes.string,
  children: PropTypes.any.isRequired,
  onChange: PropTypes.func,
  changeId: PropTypes.string,
  expanded: PropTypes.bool,
};

export default MyExpansionPanel
